import { useEffect, useState } from "react";
import axios from "axios";
import {deleteProfile, updateProfileWithImage,} from "../redux/profileFilterSlice";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../components/Layout/Sidebar";
// import "./Dashboard.css";
import "./ProfileLists.css";
import { fetchMatches, fetchProfiles } from "../redux/matchFilterSlice";
import userAvatar from "../img/user-avatar.png";
import Loader from "./Loader";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { useRef } from "react";


const TABS = ["Basic", "Professional", "Lifestyle", "Preferences"];

const getCastBasedonReligion = (setCaste, allFilterTypes, religionId) => {
  // Implementation for fetching castes based on religion
  console.log("Fetching castes for religion:", religionId);
  if (!religionId) {
    setCaste(allFilterTypes.filter((f) => f.masterType === "Caste"));
    return;
  }
  const castes = allFilterTypes.filter(
    (f) => f.masterType === "Caste" && f.parentId?._id === religionId,
  );
  setCaste(castes);
  console.log("caste:", castes);
};
const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "8px",
  border: "1.5px solid #f0e6f0",
  background: "#fdf7fd",
  color: "#4a1942",
  fontSize: "14px",
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "inherit",
  transition: "border 0.2s",
};

const labelStyle = {
  fontSize: "11px",
  fontWeight: "700",
  letterSpacing: "0.08em",
  color: "#8b5e8b",
  marginBottom: "5px",
  display: "block",
};

const fieldGroup = {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
};

const heights = [
  "4'10\"",
  "5'0\"",
  "5'2\"",
  "5'4\"",
  "5'6\"",
  "5'8\"",
  "5'10\"",
  "6'0\"",
  "6'2\"",
  "6'4\"",
  "6'6\"",
  "6'8\"",
  "6'10\"",
  "7'0\"",
];

function Field({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  required,
  limit,
}) {
  console.log("label:", label);

  const [focused, setFocused] = useState(false);
  
  return (
    <div style={fieldGroup}>
      <label style={labelStyle}>
        {label} {required && <span style={{ color: "#c0396b" }}>*</span>}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          ...inputStyle,
          border: focused ? "1.5px solid #9b4dca" : "1.5px solid #f0e6f0",
        }}
        maxLength={label === "MOBILE NUMBER" ? limit : undefined}
      />
    </div>
  );
}

function SelectField({ label, value, onChange, options }) {
  const [focused, setFocused] = useState(false);
  return (
    <div style={fieldGroup}>
      <label style={labelStyle}>{label}</label>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        style={{
          ...inputStyle,
          border: focused ? "1.5px solid #9b4dca" : "1.5px solid #f0e6f0",
        }}
      >
        <option value="">Select</option>

        {options?.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
}

// function SelectField({ label, value, onChange, options }) {
//   const [focused, setFocused] = useState(false);
//   return (
//     <div style={fieldGroup}>
//       <label style={labelStyle}>{label}</label>
//       <select
//         value={value?.toUpperCase()}
//         onChange={(e) => onChange(e.target.value)}
//         onFocus={() => setFocused(true)}
//         onBlur={() => setFocused(false)}
//         style={{
//           ...inputStyle,
//           border: focused ? "1.5px solid #9b4dca" : "1.5px solid #f0e6f0",
//         }}
//       >
//         <option value="">Select</option>
//         {options.map((opt) => (
//           <option key={opt}>{opt}</option>
//         ))}
//       </select>
//     </div>
//   );
// }

function TextAreaField({ label, value, onChange, placeholder }) {
  const [focused, setFocused] = useState(false);
  return (
    <div style={fieldGroup}>
      <label style={labelStyle}>{label}</label>
      <textarea
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          ...inputStyle,
          minHeight: "90px",
          border: focused ? "1.5px solid #9b4dca" : "1.5px solid #f0e6f0",
        }}
      />
    </div>
  );
}

/* ---------------- TABS ---------------- */

function BasicTab({
  data,
  setData,
  religion,
  caste,
  states,
  motherTongue,
  allFilterTypes,
  setCaste,
}) {
  console.log("BasicTab:", data);
  console.log("setData:", setData);
  const update = (k) => (v) => setData((d) => ({ ...d, [k]: v }));

  return (
    <div
      style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}
    >
      <Field
        label="FULL NAME"
        value={data?.fullName}
        onChange={update("fullName")}
      />
      <Field
        label="EMAIL"
        value={data?.email}
        onChange={update("email")}
        required={true}
      />
      <Field
        label="MOBILE NUMBER"
        value={data?.phone}
        onChange={update("phone")}
        required={true}
        limit={10}
      />
      <Field
        label="AGE"
        type="number"
        value={data?.age}
        onChange={update("age")}
      />
      <SelectField
        label="Height"
        value={data?.height}
        onChange={update("height")}
        options={heights}
      />
      {/* <Field label="HEIGHT" value={data.height} onChange={update("height")} /> */}
      {/* <Field
        label="MOTHER TONGUE"
        value={data?.motherTongue}
        onChange={update("motherTongue")}
      /> */}

      {/* mother tongue    */}
      <SelectField
        label="MOTHER TONGUE"
        value={data?.motherTongue}
        onChange={update("motherTongue")}
        options={motherTongue?.map((m) => m.masterValue?.["en"])}
      />

      <SelectField
        label="RELIGION"
        value={data?.religion}
        onChange={(value) => {
          update("religion")(value); // ✅ THIS WAS MISSING

          const selected = allFilterTypes.find(
            (f) => f.masterType === "Religion" && f.masterValue?.["en"] === value,
          );

          getCastBasedonReligion(
            setCaste,
            allFilterTypes,
            selected?._id || null,
          );

          update("caste")(""); // optional: reset caste when religion changes
        }}
        options={religion
          .filter((r) => r.masterType === "Religion")
          .map((r) => r.masterValue?.["en"])}
      />
      {/* <Field label="RELIGION" value={data.religion} onChange={update("religion")} /> */}

      <SelectField
        label="CASTE"
        value={data?.caste}
        onChange={update("caste")}
        options={caste.map((c) =>
          c.masterType === "Caste" ? c.masterValue?.["en"] : "",
        )}
      />
      {/* <Field label="CASTE" value={data.caste} onChange={update("caste")} /> */}

      <SelectField
        label="State"
        value={data?.state}
        onChange={(value) => {
          update("state")(value);
          update("city")(""); // reset city when state changes
        }}
        options={allFilterTypes
          .filter((f) => f.masterType === "State")
          .map((s) => s.masterValue?.["en"])}
      />

      <SelectField
        label="City"
        value={data?.city}
        onChange={update("city")}
        options={allFilterTypes
          .filter(
            (f) =>
              f.masterType === "City" &&
              (data?.state ? f.parentId?.masterValue?.["en"] === data.state : true),
          )
          .map((c) => c.masterValue?.["en"])}
      />
      {/* <Field label="LOCATION" value={data.location} onChange={update("location")} /> */}

      <SelectField
        label="MARITAL STATUS"
        value={data?.maritalStatus}
        onChange={update("maritalStatus")}
        options={["Never Married", "Divorced", "Widowed"]}
      />

      <SelectField
        label="Gender"
        value={data?.gender}
        onChange={update("gender")}
        options={["Male", "Female", "Other"]}
      />

      <TextAreaField
        label="ABOUT ME"
        value={data?.aboutMe}
        onChange={update("aboutMe")}
      />
    </div>
  );
}

function ProfessionalTab({
  data,
  setData,
  profession,
  education,
  incomeRanges,
  allFilterTypes,
}) {
  console.log("ProfessionalTab", data);
  console.log("profession", profession);
  console.log("education", education);
  console.log("incomeRanges", incomeRanges);

  const update = (k) => (v) => setData((d) => ({ ...d, [k]: v }));
  return (
    <div
      style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}
    >
      <SelectField
        label="PROFESSION"
        value={data.profession}
        onChange={update("profession")}
        options={allFilterTypes
          .filter((f) => f.masterType === "Occupation")
          .map((p) => p.masterValue?.["en"])}
      />
      {/* <Field label="PROFESSION" value={data.profession} onChange={update("profession")} /> */}

      {/* if profession is other need to show text field to enter profession details */}
      {data.profession === "Others" && (
        <Field
          label="PROFESSION DETAILS"
          value={data.professionDetails}
          onChange={update("professionDetails")}
        />
      )}

      <SelectField
        label="EDUCATION"
        value={data.education}
        onChange={update("education")}
        options={allFilterTypes
          .filter((f) => f.masterType === "Education")
          .map((e) => e.masterValue?.["en"])}
      />
      <SelectField
        label="MONTHLY SALARY"
        value={data.salary}
        onChange={update("salary")}
        options={incomeRanges}
      />
    </div>
  );
}

function LifestyleTab({ data, setData, basicData }) {
  console.log("LifestyleTab:", data);
  console.log("basicData:", basicData);

  const update = (k) => (v) => setData((d) => ({ ...d, [k]: v }));
  return (
    <div
      style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}
    >
      <SelectField
        label="DIET"
        value={data.diet}
        onChange={update("diet")}
        options={["Vegetarian", "Non-Vegetarian"]}
      />

      {/* // not show smoking & drinking fields for female profile */}
      {basicData?.gender !== "Female" && (
        <>
          <SelectField
            label="SMOKING"
            value={data.smoking}
            onChange={update("smoking")}
            options={["Never", "Occasionally"]}
          />


          <SelectField
            label="DRINKING"
            value={data.drinking}
            onChange={update("drinking")}
            options={["Never", "Occasionally"]}
          />
        </>
      )
      }
    </div>
  );
}

function PreferencesTab({
  data,
  setData,
  allFilterTypes,
  religion,
  caste,
  states,
  setCaste,
  incomeRanges,
}) {
  console.log("PreferencesTab:", data);
  console.log("setData:", setData);

  const update = (k) => (v) => setData((d) => ({ ...d, [k]: v }));
  return (
    <div
      style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}
    >
      <Field label="MIN AGE" value={data.minAge} onChange={update("minAge")} />
      <Field label="MAX AGE" value={data.maxAge} onChange={update("maxAge")} />
      <SelectField
        label="Height"
        value={data.height}
        onChange={update("height")}
        options={heights}
      />
      <SelectField
        label="EDUCATION"
        value={data.education}
        onChange={update("education")}
        options={allFilterTypes
          .filter((f) => f.masterType === "Education")
          .map((e) => e.masterValue?.["en"])}
      />
      <SelectField
        label="RELIGION"
        value={data.religion}
        onChange={(value) => {
          update("religion")(value); // ✅ THIS WAS MISSING

          const selected = allFilterTypes.find(
            (f) => f.masterType === "Religion" && f.masterValue?.["en"] === value,
          );

          getCastBasedonReligion(
            setCaste,
            allFilterTypes,
            selected?._id || null,
          );

          update("caste")(""); // optional: reset caste when religion changes
        }}
        options={religion
          .filter((r) => r.masterType === "Religion")
          .map((r) => r.masterValue?.["en"])}
      />
      {/* <Field label="RELIGION" value={data.religion} onChange={update("religion")} /> */}

      <SelectField
        label="CASTE"
        value={data.caste}
        onChange={update("caste")}
        options={caste.map((c) =>
          c.masterType === "Caste" ? c.masterValue?.["en"] : "",
        )}
      />
      {/* <Field label="CASTE" value={data.caste} onChange={update("caste")} /> */}

      <SelectField
        label="State"
        value={data.state}
        onChange={(value) => {
          update("state")(value);
          update("city")(""); // reset city when state changes
        }}
        options={allFilterTypes
          .filter((f) => f.masterType === "State")
          .map((s) => s.masterValue?.["en"])}
      />

      <SelectField
        label="City"
        value={data.city}
        onChange={update("city")}
        options={allFilterTypes
          .filter(
            (f) =>
              f.masterType === "City" &&
              (data.state ? f.parentId?.masterValue?.["en"] === data.state : true),
          )
          .map((c) => c.masterValue?.["en"])}
      />

      <SelectField
        label="PROFESSION"
        value={data.profession}
        onChange={update("profession")}
        options={allFilterTypes
          .filter((f) => f.masterType === "Occupation")
          .map((p) => p.masterValue?.["en"])}
      />

        {/* if profession is other need to show text field to enter profession details */}
      {data.profession === "Others" && (
        <Field
          label="PROFESSION DETAILS"
          value={data.professionDetails}
          onChange={update("professionDetails")}
        />
      )}

      <SelectField
        label="MONTHLY SALARY"
        value={data.salary}
        onChange={update("salary")}
        options={incomeRanges}
      />
      {/* <Field label="LOCATION" value={data.prefLocation} onChange={update("prefLocation")} /> */}
    </div>
  );
}

/* ---------------- MAIN APP ---------------- */

export default function ProfileLists({ user, userFromStore }) {


  const [cropSrc, setCropSrc] = useState(null);         // raw image preview URL
  const [crop, setCrop] = useState();                    // crop box position
  const [completedCrop, setCompletedCrop] = useState();  // final crop values
  const [showCropModal, setShowCropModal] = useState(false);
  const [pendingFile, setPendingFile] = useState(null);  // original file saved
  const imgRef = useRef(null);         

  const [activeTab, setActiveTab] = useState(0);

  const [basicData, setBasicData] = useState({});
  const [professionalData, setProfessionalData] = useState({});
  const [lifestyleData, setLifestyleData] = useState({});
  const [prefData, setPrefData] = useState({});
  const [allFilterTypes, setAllFilterTypes] = useState([]);
  const [religion, setReligion] = useState([]);
  const [caste, setCaste] = useState([]);
  const [states, setStates] = useState([]);
  const [education, setEducation] = useState([]);
  const [profession, setProfession] = useState([]);
  
  const [motherTongue, setMotherTongue] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [toast, setToast] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const { list, error } = useSelector((state) => state.matches);
  const { profiles } = useSelector((state) => state.matches);
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  const [allProfiles, setAllProfiles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingProfile, setEditingProfile] = useState(null);
  // const [activeTab, setActiveTab] = useState(0);

  const [showForm, setShowForm] = useState(false);
  const [editProfile, setEditProfile] = useState(null);

  const handleCropConfirm = async () => {
  if (!completedCrop || !imgRef.current) {
    showToast("Please select a crop area", "error");
    return;
  }

  // ── Draw cropped area to canvas ──
  const canvas = document.createElement("canvas");
  const img = imgRef.current;
  const scaleX = img.naturalWidth / img.width;
  const scaleY = img.naturalHeight / img.height;

  canvas.width = 500;
canvas.height = 494;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(
  img,
  completedCrop.x * scaleX,
  completedCrop.y * scaleY,
  completedCrop.width * scaleX,
  completedCrop.height * scaleY,
  0,
  0,
  500,  // always output 500px wide
  494   // always output 494px tall
);
canvas.toBlob((blob) => {
    if (!blob) {
      showToast("Crop failed. Try again.", "error");
      return;
    }
    const croppedFile = new File([blob], pendingFile.name, { type: pendingFile.type });
    setImage(croppedFile);                              // set for form upload
    setImagePreview(URL.createObjectURL(blob));         // set preview
    setShowCropModal(false);
    setCropSrc(null);
  }, pendingFile.type, 0.92);
};

  // image
  const [image, setImage] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 4;

let totalPages = Math.ceil(allProfiles.length / itemsPerPage);

const getPageNumbers = () => {
  const pages = [];
  const maxVisiblePages = 5;

  let startPage = Math.max(currentPage - 2, 1);
  let endPage = startPage + maxVisiblePages - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(endPage - maxVisiblePages + 1, 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return pages;
};

let startIndex = (currentPage - 1) * itemsPerPage;

const paginatedProfiles = allProfiles.slice(
  startIndex,
  startIndex + itemsPerPage
);

const goToPage = (page) => {
  if (page < 1 || page > totalPages) return;
  setCurrentPage(page);
};
  useEffect(() => {
    setLoading(true);
    dispatch(fetchMatches());
    dispatch(fetchProfiles()).finally(() => setLoading(false));
  }, [dispatch]);

  // useEffect(() => {
  //   console.log('editProfile:',editProfile);

  //   if (editProfile) {
  //     setBasicData(editProfile.basic);
  //     setProfessionalData(editProfile.professional);
  //     setLifestyleData(editProfile.lifestyle);
  //     setPrefData(editProfile.preferences);
  //     setImage(editProfile.image);
  //   }
  // }, [editProfile]);

  useEffect(() => {

    if (editProfile) {
      setActiveTab(0);
      // ✅ BASIC
      setBasicData({
        fullName: editProfile.fullName || "",
        email: editProfile?.userId?.email || "",
        phone:editProfile?.phone || "",
        age: editProfile.age || "",
        height: editProfile.height || "",
        motherTongue: editProfile.motherTongue || "",
        religion: editProfile.religion || "",
        caste: editProfile.caste || "",
        maritalStatus: editProfile.maritalStatus || "",
        state: editProfile.location?.state || "",
        city: editProfile.location?.city || "",
        gender: editProfile?.gender,
        aboutMe: editProfile.aboutMe || "",
      });

      // ✅ PROFESSIONAL
      setProfessionalData({
        profession: editProfile.profession || "",
        education: editProfile.education || "",
        salary: editProfile.salary || "",
        professionDetails: editProfile.professionDetails || "",
      });

      // ✅ LIFESTYLE
      setLifestyleData({
        diet: editProfile.diet || "",
        smoking:
          editProfile.smoking === "Non-Smoker" ? "Never" : "Occasionally",
        drinking:
          editProfile.drinking === "Non-Drinker" ? "Never" : "Occasionally",
      });

      // ✅ PREFERENCES
      setPrefData({
        minAge: editProfile.partnerPreferences?.ageFrom || "",
        maxAge: editProfile.partnerPreferences?.ageTo || "",
        height: editProfile.partnerPreferences?.height || "",
        religion: editProfile.partnerPreferences?.religion?.[0] || "",
        caste: editProfile.partnerPreferences?.caste?.[0] || "",
        city: editProfile.partnerPreferences?.city?.[0] || [],
        state: editProfile.partnerPreferences?.state?.[0] || [],
        education: editProfile.partnerPreferences?.education?.[0] || "",
        profession: editProfile.partnerPreferences?.profession?.[0] || "",
        professionDetails: editProfile.partnerPreferences?.professionDetails || "",
        salary: editProfile.partnerPreferences?.salary?.[0] || "",
      });

      // ✅ IMAGE
      const primary = editProfile.photos?.find((p) => p.isPrimary);

      setImage(
        primary?.url
          ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${primary.url}`
          : "",
      );

      // ❗ also reset preview
      // setImagePreview(image);
    }else {
      // if no profile is being edited, reset all fields
      setActiveTab(0);
      setBasicData({});
      setProfessionalData({});
      setLifestyleData({});
      setPrefData({});
      setImage(null);
      setImagePreview(null);
    }
  }, [editProfile]);

  // ── Derived display values ───────────────────────────────────────────────────
  const displayName =
    user?.username ||
    user?.name ||
    userFromStore?.username ||
    userFromStore?.name ||
    "User";

  // useEffect(() => {
  //       dispatch(fetchMatches());
  //     }, [dispatch]);

  useEffect(() => {
    console.log("profiles_list:", list?.data);

    if (list?.data) {
      const types = list.data;
      setAllFilterTypes(types);

      const religions = types
        .filter((f) => f.isActive && f.masterType === "Religion")
        .map((r) => r);

      setReligion(religions);
      console.log("religion:", religion);

      const castes = types
        .filter((f) => f.isActive && f.masterType === "Caste" && f.parentId?._id !== null)
        .map((c) => c);
      setCaste(castes);
      console.log("caste:", castes);

      //get occupation list
      const professions = types
        .filter((f) => f.isActive && f.masterType === "Occupation")
        .map((p) => p);
      setProfession(professions);
      console.log("profession:", professions);

      //get state list
      const states = types
        .filter((f) => f.isActive && f.masterType === "State")
        .map((s) => s);
      setStates(states);
      console.log("states:", states);

      //get education list
      const education = types
        .filter((f) => f.isActive && f.masterType === "Education")
        .map((e) => e);
      setEducation(education);
      console.log("education:", education);
    }

    //get mother tongue list
    const motherTongue = list?.data?.filter((f) => f.isActive && f.masterType === "Mother tongue")
      .map((m) => m);
    setMotherTongue(motherTongue);
    console.log("motherTongue:", motherTongue);
  }, [list]);

  useEffect(() => {
    console.log("apiprofiles:", profiles);
    if (profiles?.profiles) {
      setAllProfiles(profiles?.profiles);
    }
    console.log("allProfiles:", allProfiles);
  }, [profiles]);

  // const handleSave = async () => {
  //   try {
  //     const token = localStorage.getItem("token"); // ✅ get token

  //     const payload = {
  //       firstName: basicData.fullName?.split(" ")[0] || "",
  //       lastName: basicData.fullName?.split(" ")[1] || "",
  //       age: Number(basicData.age),
  //       gender: "female",

  //       maritalStatus: basicData.maritalStatus,
  //       religion: basicData.religion,
  //       caste: basicData.caste,
  //       motherTongue: basicData.motherTongue,

  //       height: basicData.height,

  //       education: professionalData.education,
  //       occupation: professionalData.profession,
  //       income: professionalData.salary,

  //       location: {
  //         // country: "India",
  //         state: prefData.prefState || "",
  //         city: prefData.prefCity || "",
  //       },

  //       diet: lifestyleData.diet,
  //       smoking: lifestyleData.smoking === "Never" ? "No" : "Yes",
  //       drinking: lifestyleData.drinking === "Never" ? "No" : "Yes",

  //       aboutMe: basicData.aboutMe,

  //       partnerPreferences: {
  //         ageRange: `${prefData.minAge}-${prefData.maxAge}`,
  //         education: prefData.prefEducation,
  //         state: prefData.prefState || "",
  //         city: prefData.prefCity || "",
  //       },
  //     };

  //     // await axios.post(
  //     //   "http://localhost:5000/api/profiles/",
  //     //   payload,
  //     //   {
  //     //     headers: {
  //     //       Authorization: `Bearer ${token}`, // ✅ TOKEN ADDED
  //     //     },
  //     //   }
  //     // );
  //     dispatch(updateProfile({...payload}))

  //     alert(" Profile Created Successfully");

  //   } catch (err) {
  //     console.error(err.response?.data || err);
  //     alert(" Error saving profile");
  //   }
  // };

  //   const handleSave = () => {
  //   const newProfile = {
  //     image: imagePreview || image,
  //     basic: basicData,
  //     professional: professionalData,
  //     lifestyle: lifestyleData,
  //     preferences: prefData
  //   };
  // console.log('sendrequest:', newProfile);

  //   if (editProfile) {
  //     setProfiles(prev =>
  //       prev.map(p => (p === editProfile ? newProfile : p))
  //     );
  //   } else {
  //     setProfiles(prev => [...prev, newProfile]);
  //   }

  //   setShowForm(false);
  // };

  // const handleSave = async () => {
  //   try {
  //     const formData = new FormData();

  //     // ✅ file
  //     if (imageFile) {
  //       formData.append("image", imageFile);
  //     }
  // console.log('basicData:',basicData);

  //     // ✅ flat payload (same as your normal API)
  //     formData.append("fullName", basicData.fullName || "");
  //     formData.append("age", Number(basicData.age) || "");
  //     formData.append("religion", basicData.religion || "");
  //     formData.append("location",   JSON.stringify({'state': basicData?.state || "", 'city': basicData?.city || ""}));
  //     formData.append("caste", basicData.caste || "");

  //     // formData.append("state", prefData.prefState || "");
  //     // formData.append("city", prefData.prefCity || "");

  //     formData.append("profession", professionalData.profession || "");
  //     formData.append("salary", professionalData.salary || "");
  //     formData.append("education", professionalData.education || "");

  //     formData.append("height", basicData.height || "");
  //     formData.append("motherTongue", basicData.motherTongue || "");
  //     formData.append("maritalStatus", basicData.maritalStatus || "");
  //     formData.append("gender", basicData.gender || "");

  //     formData.append("diet", lifestyleData.diet || "");
  //     formData.append(
  //       "smoking",
  //       lifestyleData.smoking === "Never" ? "Non-Smoker" : "Smoker"
  //     );
  //     formData.append(
  //       "drinking",
  //       lifestyleData.drinking === "Never" ? "Non-Drinker" : "Drinker"
  //     );

  //     formData.append("aboutMe", basicData.aboutMe || "");

  //     // ✅ preferences
  //     console.log('prefData:',prefData);

  //     let preferences ={
  //       'ageFrom': prefData.minAge || "",
  //       'ageTo': prefData.maxAge || "",
  //       'height': prefData.height || "",
  //       'religion': [prefData.religion || ""],
  //       'caste': [prefData.caste || ""],
  //       'state': [prefData.state || ""],
  //       'city': [prefData.city || ""],
  //       'profession': [prefData.profession || ""],
  //       'education': [prefData.education || ""],
  //       'salary': [prefData.salary || ""],
  //     };
  //     formData.append("partnerPreferences", JSON.stringify(preferences));
  //     // formData.append("prefAgeMin", prefData.minAge || "");
  //     // formData.append("prefAgeMax", prefData.maxAge || "");
  //     // formData.append("prefHeight", prefData.prefHeight || "");
  //     // formData.append("prefReligion", prefData.prefReligion || "");
  //     // formData.append("prefCaste", prefData.prefCaste || "");
  //     // formData.append("prefEducation", prefData.prefEducation || "");

  //     // // arrays (important)
  //     // formData.append("prefState", JSON.stringify(prefData.prefState || []));
  //     // formData.append("prefCity", JSON.stringify(prefData.prefCity || []));
  //     // formData.append("prefProfession", JSON.stringify(prefData.prefProfession || []));
  //     // formData.append("prefSalaryMin", JSON.stringify(prefData.prefSalaryMin || []));

  //     // 🧪 debug
  //     for (let pair of formData.entries()) {
  //       console.log(pair[0], pair[1]);
  //     }

  //     const editId = editProfile?._id;
  // console.log('editId:', editId);
  // console.log('formData',formData);

  //     if (editId) {
  //       await dispatch(updateProfileWithImage({ id: editId, formData })).unwrap();
  //     } else {
  //       await dispatch(updateProfileWithImage({ formData })).unwrap();
  //     }

  //     dispatch(fetchProfiles()); // refresh list after update
  //     setShowForm(false);

  //   } catch (err) {
  //     console.error(err);
  //   }
  // };
const handleSave = async () => {
  // add validation form filds here if needed
  if (!basicData?.fullName || !basicData?.email || !basicData?.phone || !basicData?.age || !lifestyleData?.diet || (basicData?.gender !== "Female" &&
    (!lifestyleData?.smoking || !lifestyleData?.drinking)) || !professionalData?.profession || !professionalData?.education) {
    showToast("Fill all required fields", "error");
    return;
  }

  const formData = new FormData();

  formData.append("fullName", basicData.fullName || "");
  formData.append("email", basicData.email || "");
  formData.append("phone",basicData.phone || "");
  formData.append("age", basicData.age || "");
  formData.append("height", basicData.height || "");
  formData.append("motherTongue", basicData.motherTongue || "");
  formData.append("gender", basicData.gender || "");
  formData.append("maritalStatus", basicData.maritalStatus || "");

  formData.append("religion", basicData.religion || "");
  formData.append("caste", basicData.caste || "");

  formData.append(
    "location",
    JSON.stringify({
      state: basicData.state || "",
      city: basicData.city || "",
    })
  );

  formData.append("profession", professionalData.profession || "");
  formData.append("professionDetails", professionalData.professionDetails || "");
  formData.append("education", professionalData.education || "");
  formData.append("salary", professionalData.salary || "");

  formData.append("diet", lifestyleData.diet || "");
  formData.append("smoking", lifestyleData.smoking || "No");
  formData.append("drinking", lifestyleData.drinking || "No");

  //make generate about me from other fields if not provided by user
  if (!basicData.aboutMe) {
    const aboutMe = `I am a ${basicData.gender || "person"} looking for a life partner. I am ${basicData.age || "a certain age"} and currently working as a ${professionalData.profession || "professional"}.`;
    formData.append("aboutMe", aboutMe);
  } else {
    formData.append("aboutMe", basicData.aboutMe || "");
  }

  // ✅ ADD THIS (CRITICAL FIX)
  const preferences = {
    ageFrom: prefData.minAge || "",
    ageTo: prefData.maxAge || "",
    height: prefData.height || "",
    religion: [prefData.religion || ""],
    caste: [prefData.caste || ""],
    state: [prefData.state || ""],
    city: [prefData.city || ""],
    education: [prefData.education || ""],
    profession: [prefData.profession || ""],
    professionDetails: prefData.professionDetails || "",
    salary: [prefData.salary || ""],
  };

  formData.append("partnerPreferences", JSON.stringify(preferences));

  // ✅ IMAGE
  if (image) {
    formData.append("image", image);
  }

  setLoading(true);
  await dispatch(
    updateProfileWithImage({
      id: editProfile?._id,
      formData,
    })
  )    .unwrap()
    .then(() => {
      dispatch(fetchProfiles()); // refresh after save
      setShowForm(false);
    })
    .catch((err) => {
      console.log("Save error:", err);
      showToast(err, "error");
      console.error(err);
    })
    .finally(() => setLoading(false));
};
  // const incomeRanges = ["3–6L", "6–12L", "12–25L", "25L+"];
  const incomeRanges = [
  "Below 10K",
  "10K – 25K",
  "25K – 50K",
  "50K – 1L",
  "1L – 2L",
  "2L+"
];

  // delete profile
  const deleteUserProfile = async (id) => {
    try {
      await dispatch(deleteProfile(id)).unwrap();
      dispatch(fetchProfiles()); // refresh list after deletion
    } catch (err) {
      console.error(err);
    }
  };

  // ── Toast helper ─────────────────────────────────────────────────────────────
  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const filteredUsers = search
  ? allProfiles.filter((item) =>
      item.fullName
        ?.toLowerCase()
        .includes(search.toLowerCase())
    )
  : paginatedProfiles;


  return (
    <div className="app">
      {loading && <Loader />}
      <Sidebar />
      <main className="main">
        {/* Header */}
        <div className="main-header">
          <div className="main-header-left">
            <h1 className="page-title">
              Matrimony <span>Profiles</span>
            </h1>
            <p className="page-sub">
              Welcome back, <strong>{displayName}</strong>
            </p>
          </div>
          <div className="main-header-right"></div>
        </div>
        {/* <div style={{ display: "flex", gap: "10px" }}>
        {TABS.map((t, i) => (
          <button key={i} onClick={() => setActiveTab(i)}>
            {t}
          </button>
        ))}
      </div> */}

        <div className="tab-content">
          <div className="profile-list-container">
            {/* Header */}
            {!showForm && (
              <div className="story-header">
                <h3>Profiles</h3>
                <div className="header-actions">
                  <input
                    type="text"
                    placeholder="Search by name"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="search-input"
                  />
                  <button
                    className="add-btn"
                    onClick={() => {
                      setEditProfile(null);
                      setShowForm(true);
                      setBasicData({});
                      setProfessionalData({});
                      setLifestyleData({});
                      setPrefData({});
                      setImage(null);
                      setImagePreview(null);
                      setActiveTab(0);
                  }}
                >
                  + Add Profile
                </button>
              </div>
              </div>
            )}

            {/* TABLE */}
            {!showForm && (
              <div className="table-wrapper">
                <table className="story-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Image</th>
                      <th>Name</th>
                      <th>Age</th>
                      <th>Profession</th>
                      <th>Location</th>
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredUsers.length === 0 ? (
                      <tr>
                        <td colSpan="7">No profiles found</td>
                      </tr>
                    ) : (
                      filteredUsers.map((p, index) => {
                        const primary = p.photos.find((p) => p.isPrimary);
                        console.log("primary:", primary);

                        const location = [
                          p?.location?.city,
                          p?.location?.state,
                          p?.location?.country,
                        ]
                          .filter(Boolean)
                          .join(", ");
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <img
                                src={`${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${primary?.url}`}
                                alt=""
                                className="story-img"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = userAvatar;
                                }}
                              />
                            </td>

                            <td>{p.fullName}</td>
                            <td>{p.age}</td>
                            <td>{p.profession}</td>
                            <td>{location}</td>

                          <td>
                            <button
                              className="edit-btn"
                              onClick={() => {
                                setEditProfile(p);
                                setShowForm(true);
                              }}
                              title="Edit"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                              </svg>
                            </button>

                            <button
                              className="delete-btn"
                              onClick={() => deleteUserProfile(p._id)}
                              title="Delete"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <polyline points="3 6 5 6 21 6" />
                                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                <path d="M10 11v6" />
                                <path d="M14 11v6" />
                                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                              </svg>
                            </button>
                          </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* FORM (your tab form inside) */}
            {showForm && (
              <div className="form-card">
                {/* Profile Upload Section */}
                <div className="profile-section">
                  <div className="image-wrapper">
                    {image && (
                      <img
                        src={imagePreview || image || "/default-avatar.png"}
                        alt="profile"
                         onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = userAvatar;
                          }}
                      />
                    )}
                  </div>
                    <label className="upload-btn">
                      {image ? "Change Image" : "Upload Image"}
                      <input
                        type="file"
                        hidden
                        accept="image/jpeg,image/png,image/webp,image/gif"
                        onChange={(e) => {
                          const file = e.target.files[0];

                          if (!file) return;
                          const allowedTypes = [
                            "image/jpeg",
                            "image/png",
                            "image/webp",
                            "image/gif",
                          ];

                          if (!allowedTypes.includes(file.type)) {
                            showToast(
                              "Only JPG, PNG, WEBP, or GIF images are allowed",
                              "error"
                            );

                            e.target.value = "";
                            return;
                          } 
                          if (file.size > 2 * 1024 * 1024) {
                            const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);

                            showToast(
                              `Image too large (${fileSizeMB} MB). Maximum allowed size is 2MB`,
                              "error"
                            );
                            e.target.value = "";
                            return;
                          }
                          const reader = new FileReader();
                          reader.onload = () => {
                            setCropSrc(reader.result);
                            setPendingFile(file);
                            setShowCropModal(true);
                          };
                          reader.readAsDataURL(file);
                          e.target.value = "";

                        }}
                      />
                    </label>
                  </div>

                {/* Tabs */}
                <div className="tabs">
                  {TABS.map((t, i) => (
                    <button
                      key={i}
                      className={activeTab === i ? "tab active" : "tab"}
                      onClick={() => setActiveTab(i)}
                    >
                      {t}
                    </button>
                  ))}
                </div>

                {/* Tab Content */}
                <div style={{ marginTop: "20px" }}>
                  {activeTab === 0 && (
                    <BasicTab
                      data={basicData}
                      setData={setBasicData}
                      religion={religion}
                      caste={caste}
                      states={states}
                      allFilterTypes={allFilterTypes}
                      setCaste={setCaste}
                      motherTongue={motherTongue}
                    />
                  )}
                  {activeTab === 1 && (
                    <ProfessionalTab
                      data={professionalData}
                      setData={setProfessionalData}
                      profession={profession}
                      education={education}
                      incomeRanges={incomeRanges}
                      allFilterTypes={allFilterTypes}
                    />
                  )}
                  {activeTab === 2 && (
                    <LifestyleTab
                      data={lifestyleData}
                      setData={setLifestyleData}
                      basicData={basicData}
                    />
                  )}
                  {activeTab === 3 && (
                    <PreferencesTab
                      data={prefData}
                      setData={setPrefData}
                      allFilterTypes={allFilterTypes}
                      religion={religion}
                      caste={caste}
                      states={states}
                      setCaste={setCaste}
                      incomeRanges={incomeRanges}
                    />
                  )}
                </div>

                {/* Actions */}
                <div className="form-actions">
                  <button className="btn save-btn" onClick={handleSave}>
                    {editProfile ? "Update Profile" : "Create Profile"}
                  </button>

                  <button
                    className="btn cancel-btn"
                    onClick={() => {
                      setShowForm(false);
                      setEditProfile(null);
                      setImagePreview(null); // optional reset
                      setImageFile(null); // optional reset
                    }}
                  >
                    Cancel
                  </button>
                </div>
                {/* <button onClick={handleSave}>Save</button>
        <button
          onClick={() => {
            setShowForm(false);
            setEditProfile(null);
          }}
        >
          Cancel
        </button> */}
              </div>
            )}
          </div>
        </div>

        {/* <div style={{ marginTop: "20px" }}>
        {activeTab === 0 && <BasicTab data={basicData} setData={setBasicData} />}
        {activeTab === 1 && <ProfessionalTab data={professionalData} setData={setProfessionalData} />}
        {activeTab === 2 && <LifestyleTab data={lifestyleData} setData={setLifestyleData} />}
        {activeTab === 3 && <PreferencesTab data={prefData} setData={setPrefData} />}
      </div>

      <button onClick={handleSave} style={{ marginTop: "20px" }}>
        Save
      </button> */}
    {totalPages > 1 && (
    <div className="pagination">
    <button
      onClick={() => goToPage(currentPage - 1)}
      disabled={currentPage === 1}
    >
      Prev
    </button>

    {getPageNumbers().map((page) => (
      <button
        key={page}
        className={currentPage === page ? "active" : ""}
        onClick={() => goToPage(page)}
      >
        {page}
      </button>
    ))}

    <button
      onClick={() => goToPage(currentPage + 1)}
      disabled={currentPage === totalPages}
    >
      Next
    </button>
  </div>
)}

{/* ── Crop Modal ── */}
{showCropModal && cropSrc && (
  <div
    className="overlay"
    style={{ zIndex: 9999 }}
    onClick={(e) => e.target === e.currentTarget && setShowCropModal(false)}
  >
    <div
      className="modal"
      style={{
        maxWidth: 520, width: "95%", padding: 0,
        borderRadius: 16, overflow: "hidden",
        maxHeight: "90vh", display: "flex", flexDirection: "column",
      }}
    >
      <div className="modal-header" style={{ padding: "16px 20px", borderBottom: "1px solid #e9d5ff" }}>
        <div className="modal-title" style={{ fontSize: 16 }}>Crop Your Photo</div>
        <button className="close-btn" onClick={() => { setShowCropModal(false); setCropSrc(null); }}>✕</button>
      </div>

      <div style={{ padding: "8px 20px", background: "#faf5ff", fontSize: 12, color: "#7c3aed", borderBottom: "1px solid #e9d5ff" }}>
      </div>

      <div style={{ padding: 12, background: "#1a1a2e", display: "flex", justifyContent: "center", flex: 1, overflowY: "auto" }}>
        <ReactCrop
          crop={crop}
          onChange={(c) => setCrop((prev) => ({ ...prev, x: c.x, y: c.y }))}
          onComplete={(c) => setCompletedCrop((prev) => ({ ...prev, x: c.x, y: c.y }))}
          style={{ maxHeight: 340 }}
        >
          <img
            ref={imgRef}
            src={cropSrc}
            alt="crop-preview"
            style={{ maxWidth: "100%", maxHeight: 340, display: "block" }}
            onLoad={(e) => {
              const { width, height } = e.currentTarget;
              const scaleX = width / e.currentTarget.naturalWidth;
              const scaleY = height / e.currentTarget.naturalHeight;
              const cropW = Math.min(500 * scaleX, width);
              const cropH = Math.min(494 * scaleY, height);
              const x = (width - cropW) / 2;
              const y = (height - cropH) / 2;
              const initialCrop = { unit: "px", x, y, width: cropW, height: cropH };
              setCrop(initialCrop);
              setCompletedCrop(initialCrop);
            }}
          />
        </ReactCrop>
      </div>

      <div className="modal-footer" style={{ padding: "14px 20px", borderTop: "1px solid #e9d5ff", display: "flex", gap: 10, justifyContent: "flex-end" }}>
        <button className="btn-cancel" onClick={() => { setShowCropModal(false); setCropSrc(null); }}>Cancel</button>
        <button className="btn-save" onClick={handleCropConfirm}>Upload </button>
      </div>
    </div>
  </div>
)}
      </main>
      
      {toast && <div className={`toast ${toast.type}`}>{toast.msg}</div>}
    </div>
  ); 
};